module.exports = __webpack_public_path__ + "img/mealreminder-user-4.7c895b42.png";